import { useState, useEffect } from 'react';
import { Wifi, WifiOff } from 'lucide-react';
import { API } from '../utils/apiConfig';

/**
 * ConnectionStatus — small indicator in the navigation bar.
 * Shows green dot when Socket.IO + Push backend is reachable.
 * Shows red dot + error message if connectivity check fails.
 */
export const ConnectionStatus = () => {
  const [status, setStatus] = useState('checking'); // checking | ok | error
  const [detail, setDetail] = useState('');

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const resp = await fetch(`${API}/connectivity/status`, { signal: AbortSignal.timeout(5000) });
        if (!cancelled) {
          if (resp.ok) {
            setStatus('ok');
          } else {
            setStatus('error');
            setDetail(`Backend returned ${resp.status}`);
          }
        }
      } catch {
        if (!cancelled) {
          setStatus('error');
          setDetail('Cannot reach server');
        }
      }
    };

    check();
    const interval = setInterval(check, 30000); // Re-check every 30s

    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  if (status === 'checking') return null;
  if (status === 'ok') return null; // Don't show anything when healthy

  return (
    <div
      data-testid="connection-status-error"
      title={detail}
      style={{
        display: 'flex', alignItems: 'center', gap: '6px',
        padding: '4px 12px', borderRadius: '20px',
        background: '#fef2f2', border: '1px solid #fecaca',
        fontSize: '0.75rem', fontWeight: 600, color: '#dc2626',
        cursor: 'help',
      }}
    >
      <WifiOff size={14} />
      Offline
    </div>
  );
};
